module.exports = __webpack_public_path__ + "img/dark_box3_icon1.ce4b1097.png";